import type { Lexer } from '@parser';
import { Token } from '@parser';

// Parses a quoted JSON string, including escape sequences within the quotes.
// Uses JSON.parse to unescape the string.
export class JSONString extends Token<string> {
  static lex(lexer: Lexer): JSONString | undefined {
    return lexer.withContext('String', () => {
      // Parse the open quote (single or double)
      const match = lexer.match(/^"(?:\\.|[^"\\])*"|^'(?:\\.|[^'\\])*'/);
      if (!match) {
        return undefined;
      }
      lexer.consume(match);
      try {
        let parseText = match.text;
        if (match.text.startsWith("'")) {
          const inner = match.text.slice(1, -1).replace(/"/g, '\\"');
          parseText = `"${inner}"`;
        }
        const value = JSON.parse(parseText) as string;
        return new JSONString(match.text, {
          start: match.start,
          end: match.end,
          value
        });
      } catch (err) {
        let message = 'Unknown error';
        if (err instanceof SyntaxError) {
          message = err.message;
        }
        lexer.error(`Invalid string: ${message}`, match.start);
        return undefined;
      }
    });
  }
}
